module.exports = "/_next/static/images/JettyBackground-3adec90aee1282d807faf072589c12f1.png";